import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import Institucion from './components/Institucion';

export default function indexRole() {
    return (
      <>
        <MainContent titulo='Administración de Instituciones' component={ <Institucion /> } />        
        
        <Outlet />
      </>
    );      
}